import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_2 = { class: "max-w-[1040px]" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-end mt-4"
}

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

import ListFilterEditor from '@/components/neue/ListFilterEditor.vue'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import { useToast } from '@/composables/useToast'
import { listPath } from '@/config/listSections'
import { mergeFilter, newListAttributes } from '@/helpers/filters'
import { planLimitError } from '@/helpers/planLimits'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'


export default {
  __name: 'NewListNeue',
  setup(__props) {

const router = useRouter()
const { showToast } = useToast()

const name = ref('')
const filters = ref([])
const saving = ref(false)
let nextFilterId = 1

const canUpdateCustomers = computed(() => privilegeService.canAccessResourceAction('customers', null, 'update'))

const canSave = computed(() => filters.value.length > 0 && name.value.trim() !== '')

const changeFilter = filter => {
  filters.value = mergeFilter(filters.value, filter.id ? filter : { ...filter, id: nextFilterId++ })
}

const save = async () => {
  saving.value = true
  try {
    const response = await api.call('POST', 'audiences', {
      audience: newListAttributes(name.value.trim(), filters.value)
    })
    await router.replace(listPath(response.data.data.id))
  } catch (error) {
    const message = planLimitError(error)
    if (!message) throw error
    showToast(message, { type: 'error' })
  } finally {
    saving.value = false
  }
}

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_InputField = _resolveComponent("InputField")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: name.value.trim() || 'New list'
      }, null, 8, ["text"])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SettingsSection, {
            title: "Details",
            description: "What this list is called here and anywhere you pick it, like automations and drops."
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputField, {
                modelValue: name.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((name).value = $event)),
                name: "Name",
                placeholder: "e.g. Weekly regulars"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(SettingsSection, {
            title: "Filters",
            description: "Who is in this list. Nothing is saved until you save the list.",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createVNode(ListFilterEditor, {
                filters: filters.value,
                onChange: changeFilter
              }, null, 8, ["filters"]),
              (canUpdateCustomers.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_NeueButton, {
                      type: canSave.value ? 'primary' : 'inactive',
                      loading: saving.value,
                      onClick: save
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode(" Save list ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["type", "loading"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

}